export const mainImageText = {
  imgUrl: '/images/interview/shizutetsu/interview_top.jpg',
  mobileImgUrl: '/images/interview/shizutetsu/interview_top_sp.jpg',
  message: `お世話になった方々へ、
遠くにいてもお別れの場を
  提供したい。`,
}

export const customerVoiceText = {
  company: 'しずてつソーサレア',
  companyLocation: '静岡県',
  companyUrl: 'https://www.st-sosarea.co.jp/',
  companyImg: '/images/interview/shizutetsu/shizutetsu-sosarea.jpg',
  readText: `しずてつソーサレア様は、2020年11月より@葬儀を導入いただきました。多くの喪主様にご案内いただき、静岡県では初となるオンライン葬儀を実施、その後も着実に実施件数を伸ばしていらっしゃいます。
弊社とも、導入にあたってのフォローにとどまらず、様々な意見交換、課題の共有を通し、パートナーシップをもって対応いただいております。
今回はしずてつソーサレア田村様に＠葬儀導入の経緯や、実際に使ってみての感想や喪主様の意見、また今後の展開などについてお伺いいたしました。`,
  infoText: `株式会社しずてつソーサレア様は、静岡県静岡市を拠点に2007年に創業。
  地域に密着した「安心・明瞭な葬祭サービス」を提供されており、毎月セミナーやカルチャー講座を開催するなど文化事業にも積極的に取り組まれています。その活動は葬祭業の範疇のみならず、明るく、健やかな老後の過ごし方などを積極的にご提案し、地域のみなさまに寄り添った事業を展開されています。`,
}

export const shizutesuQA = [
  {
    question: 'なぜオンライン葬儀を検討されたのでしょうか？',
    answer: `コロナ禍の影響で、お葬儀への参列が困難となるなかで、喪主様・ご会葬者様に故人様とのお別れの場を設けるための施策の一つとしてオンライン葬儀の導入が社内会議で決まりました。
その時導入の進め方についてどうしようか、と思っている時に＠葬儀を知り、葬儀業界の情報誌にも掲載されていた会社ということから検討させていただきました。`,
  },
  {
    question: '＠葬儀を選定したポイントは？',
    answer: `他社と比較して「会葬者目線で作られている」という点が非常に良い点でした。
＠葬儀の画面はお焼香からライブ配信、動画、写真、喪主様からのご挨拶と、一連の流れで見ることができるので、ご会葬者様にとっても非常に使いやすいのではと感じました。
中でもお焼香の機能はとても良いと思います。
ご会葬者様が単に見るだけではなく、オンライン上でお焼香ができ、お葬儀に参列したということを体感することができます。やはり、ただ画面上で葬儀を見るだけだとお気持ちを伝えづらい部分がありますから、このお焼香の機能は他社と比較するうえでも大きな決め手でした。 あとは追悼メッセージと写真のアップロード機能も喪主・ご遺族様からもとてもよろこばれています。
オンライン葬儀において喪主・ご遺族の側から一方通行になるのではなく、ご会葬者様の方からもメッセージやお写真を送っていただけるという機能は、喪主・ご遺族の方が知らない故人のお姿を見ることができるので、非常に良いシステムだと感じました。`,
  },
  {
    question: '＠葬儀を操作してみた印象はいかがですか？',
    answer: `写真や動画の取り込みがスムーズにできるところがとても使いやすいですね。
また、入力の際のテンプレートが用意されているのが良かったです。
お葬儀は限られた時間のなかでやらなければならないことがたくさんあります。
そんな中で担当者だけではなく、他のスタッフでも操作しやすい、ということが求められるので、操作性の良さやテンプレートが用意されていることは非常に助かりました。
最初こそは慣れるまでは多少時間がかかりましたが、今ではもう数分、かかっても15分もしないうちにオンライン葬儀の作成ができるようになりました。
基本的には、どのスタッフも同様に操作できるようにしています。`,
  },
  {
    question: `＠葬儀をご利用いただくことで、
解決できた課題はございますか？`,
    answer: `当社は静鉄グループの1社ということで鉄道会社としてのイメージが大きく、葬儀会社としても業界内では新しい会社です。
その中でオンライン葬儀を取り入れることにより、テレビや新聞等の多くのメディアに取り上げていただきました。「葬儀社の特徴」と言うと難しいものがあるのですが、今回＠葬儀を導入することによって、最先端のサービスを常に取り入れる会社としてブランディング向上に繋がったと思います。メディアを見られたお客様からお声がけいただき、オンライン葬儀をご注文いただいたケースもありました。オンライン葬儀自体の認知度が向上しておりますので、オンライン葬儀＝しずてつソーサレアというイメージをつけていきたいと思います。`,
  },
  {
    question: '喪主様やご遺族様、ご会葬者様の方の感想はいかがですか？',
    answer: `追悼メッセージは特に喪主様から「嬉しかった」というお声が多いですね。
例えば、親子であっても全てを知っているわけではないため、職場の方から追悼メッセージや写真をお送りいただくことで、ご遺族の方が存じ上げない故人様を知ることができ、とても嬉しかったというお声がありました。
あとは、お世話になった方の中には時間やお仕事の制約等で実際の葬儀には参列できない場合がありますが、＠葬儀を通じてお焼香が出来たり、故人様のお姿をスライドショーや写真で見ることができたと、非常に喜ばれておりました。その意味でもオンラインで葬儀場を作成することで、ご遺族の「来てほしい」想いとご会葬者様の「行きたい」という気持ちを繋ぐことができたと思います。
今後もより多くの方にご利用いただきたいと考えております。`,
  },
  {
    question: '御社で考えられている今後の展望などをお聞かせください。',
    answer: `＠葬儀をご利用いただいた喪主様・ご会葬者様からはたくさんのおよろこびの声を頂いております。
そのため、皆様にご利用いただきたいと考えているのですが、お葬儀の打ち合わせという限られた期間の中で、良さを伝えきれていないという課題があります。
今後は、＠葬儀を全葬儀プランでご提供していくことを検討しており、より多くの方にこのサービスに触れていただく機会を作っていきたいと考えております。`,
  },
]
